
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/calendar/event",
      function () {
        return require("private-next-pages/calendar/event.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/calendar/event"])
      });
    }
  